import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Shared Axios instance for all API calls
 * The auth interceptor will be set up in App.tsx after MSAL initialization
 */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 200000, // 200 segundos: el margen que pedía el procesamiento por Aura, que ya no existe; se mantiene
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
